export const navOptions=[
    
{
    id:"institucional", 
    text:"Institucional",
    sections:[
        { id: "autoridades", text: "Autoridades"},
        { id: "infoComip", text: "¿Qué es la Comip?"},
        {id:"convenios" , text:"Convenios de Cooperacion"}
    ]    
},
{
    id:"rio", 
    text:"El Río",
    sections:[
        {id:"cuencadelplata",text:"Cuenca del Plata"},
        {id:"rioparana",text:"Río Paraná"},
        {id:"tramocomip",text:"El Tramo Comip"},
    ]
},
{
    id:"fauna", 
    text:"Fauna íctica",
    sections:[
        {id:"convenio",text:"Convenio"},
        {id:"especies",text:"Especies"},
        {id:"estudios",text:"Estudios ›",subsections:[
            {id:"pescarecreativa",text:"Pesca Recreativa"},
            {id:"piscicultura",text:"Piscicultura"},
            {id:"otros",text:"Otros Estudios"},
        ]},
    ]
},
{
    id:"nav", 
    text:"Navegación",
    sections:[
        {id:'tramo',text:"Tramo COMIP ›",subsections:[
            {id:"navegacion",text:"Navegación Tramo COMIP"},
            {id:"trayectos",text:"Trayectos"},
            {id:"encarnacion",text:"Actas Grupo Encarnación"},
        ]},
        {id:'determinantes',text:"Determinantes"},
        {id:'transFluvial',text:"Transporte Fluvial ›",subsections:[
            {id:"comercial",text:"Tráfico comercial"},
            {id:"esclusa",text:"Esclusa de Yacyretá"},
            {id:"puertos",text:"Puertos"},

        ]},
        {id:'publicaciones',text:"Publicaciones"},
    ]
},
{
    id:"proyectos", 
    text:"Proyectos",
    sections:[
        {id:"energias",text:"La Energía"},
        {id:"itatiItacora",text:"Itatí-Itacorá"},
        {id:'corpusChristi',text:"Corpus Christi - Situación actual"},
    ]
},
{
    id:"agua", 
    text:"El agua",
    sections:[
        {id:'hidrometeorologia',text:"Hidrometeorología"},
        {id:'pronostico',text:"Meteorología"},
        {id:'calidad',text:"Calidad del Agua"},
    ]
},
{
    id:"mapa", 
    text:"Mapa interactivo",
    sections:[
        
    ]
},
{
    id:"contacto", 
    text:"Contacto",
    sections:[
        
    ]
}
]